import * as Types from '../../modules/decisionsNext/api/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type SourceDataUploadHistoryQueryVariables = Types.Exact<{
  externalSystemId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type SourceDataUploadHistoryQuery = { __typename?: 'Query', sourceDataUploads: { __typename?: 'SourceDataUploads', history: Array<{ __typename?: 'SourceDataUpload', id: string, amsType: Types.AmsType, fileName: string, status: Types.SourceDataUploadStatus, errors?: Array<string> | null, created: number | string, updated: number | string, downloadUrl?: string | null }> } };


export const SourceDataUploadHistoryDocument = gql`
    query SourceDataUploadHistory($externalSystemId: ID) {
  sourceDataUploads {
    history(externalSystemId: $externalSystemId) {
      id
      amsType
      fileName
      status
      errors
      created
      updated
      downloadUrl
    }
  }
}
    `;

/**
 * __useSourceDataUploadHistoryQuery__
 *
 * To run a query within a React component, call `useSourceDataUploadHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceDataUploadHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceDataUploadHistoryQuery({
 *   variables: {
 *      externalSystemId: // value for 'externalSystemId'
 *   },
 * });
 */
export function useSourceDataUploadHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>(SourceDataUploadHistoryDocument, options);
      }
export function useSourceDataUploadHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>(SourceDataUploadHistoryDocument, options);
        }
// @ts-ignore
export function useSourceDataUploadHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>;
export function useSourceDataUploadHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SourceDataUploadHistoryQuery | undefined, SourceDataUploadHistoryQueryVariables>;
export function useSourceDataUploadHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>(SourceDataUploadHistoryDocument, options);
        }
export type SourceDataUploadHistoryQueryHookResult = ReturnType<typeof useSourceDataUploadHistoryQuery>;
export type SourceDataUploadHistoryLazyQueryHookResult = ReturnType<typeof useSourceDataUploadHistoryLazyQuery>;
export type SourceDataUploadHistorySuspenseQueryHookResult = ReturnType<typeof useSourceDataUploadHistorySuspenseQuery>;
export type SourceDataUploadHistoryQueryResult = Apollo.QueryResult<SourceDataUploadHistoryQuery, SourceDataUploadHistoryQueryVariables>;